// Copyright (c) 2026 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * An SVG component that renders the full NetSuite logo with the N icon and wordmark.
 * Use this for prominent display (e.g., integration table rows).
 * For icon-only usage, use NetSuiteIcon instead.
 *
 * Supports MUI's color system: when a `color` prop is provided (e.g., "disabled",
 * "action"), the logo renders in that color (grayscale-friendly). When omitted,
 * it uses the official NetSuite brand colors.
 */
export function NetSuiteLogo(props: SvgIconProps) {
  const useLightColor = props.color ? 'currentColor' : '#baccdb';
  const useDarkColor = props.color ? 'currentColor' : '#125580';
  const useTextColor = props.color ? 'currentColor' : '#1A1919';

  return (
    <SvgIcon {...props} viewBox="0 0 550 150">
      <title>NetSuite logo</title>
      {/* N icon - light blue L-shaped brackets (scaled from netsuite-icon.tsx) */}
      <path
        d="M20.1 47.7h23.7V104h11.8v22H20.1zm109.7 51.8h-23.7V43.2H94.3v-22h35.5z"
        fill={useLightColor}
      />
      {/* N icon - dark blue diagonal shapes (scaled from netsuite-icon.tsx) */}
      <path
        d="M14.6 15.8h74.9v64.3L60.7 43H14.6zm120.6 115.7H60.3V67.2l28.8 37.1h46.1z"
        fill={useDarkColor}
      />
      {/* NETSUITE text */}
      <text
        x="160"
        y="100"
        fontFamily="Arial, sans-serif"
        fontSize="80"
        fill={useTextColor}
      >
        <tspan fontWeight="bold">NET</tspan>
        <tspan fontWeight="normal">SUITE</tspan>
      </text>
    </SvgIcon>
  );
}
